import * as React from 'react';

import { IStationInfoSchema } from '../../types';
import { isArrayWithItems, getDistanceRailway } from '../../utils/helpers';
import { StationItem } from '../station_item';

export const getStations = (regionHasStations: boolean, stationInfoList: IStationInfoSchema[]) => {
  if (!regionHasStations) {
    return null;
  }

  const station = isArrayWithItems(stationInfoList) && stationInfoList[0];
  if (!station) {
    return null;
  }

  return stationInfoList.map(item => {
    const { stationName, stationId, directionName, seo } = item;

    if (!stationName || !directionName) {
      return null;
    }

    const link = seo?.url ?? '';

    const name = `${stationName} (напр. ${directionName})`;

    return <StationItem key={stationId} link={link} stationName={name} distanceText={getDistanceRailway(item)} />;
  });
};
